export const sanitisePhoneNumber = (phoneNumber: string) => {
    let sanitisedNumber = phoneNumber;
    if (phoneNumber.charAt(0) === "0") {
        sanitisedNumber = sanitisedNumber.substring(1);
    }
    sanitisedNumber = sanitisedNumber.replace(/\s+/g, '');

    return sanitisedNumber;
}